var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTenjininline = function SvgTenjininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tenjin_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tenjin_inline_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tenjin_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C5D6A",
    fillRule: "evenodd",
    d: "M7.97 16c4.48.005 8.025-3.506 8.03-7.952A8 8 0 0 0 8.03 0C3.624-.036.006 3.564 0 7.99c-.008 4.463 3.518 8.006 7.97 8.01m7.3-7.973c-.018 3.99-3.277 7.223-7.279 7.22-3.993 0-7.262-3.26-7.262-7.239C.73 4.063 4.062.743 8.01.753c3.96.01 7.278 3.335 7.26 7.274M9.882 13.61c.724.287 1.418.265 2.105-.244l-.284-.118c-.183-.076-.356-.146-.518-.234-1.296-.702-2.01-1.764-1.964-3.268.029-.947.528-1.656 1.19-2.286.994-.947 1.698-2.033 1.594-3.487-.064-.89-.506-1.549-1.238-1.768l.02.2q.02.202.035.394c.166 2.295-1.58 4.017-3.807 3.741a4 4 0 0 1-.572-.132 7 7 0 0 0-.327-.087c-1.363-.317-2.684-.347-3.828.634-.606.521-.802 1.064-.643 1.742l.258-.168q.264-.174.526-.334c1.929-1.15 4.247-.273 4.926 1.853q.259.82.556 1.626c.354.948 1.043 1.568 1.97 1.936",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tenjin_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTenjininline;